import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Head from "@/components/Head/index.vue";
import { defineComponent, reactive, ref, toRefs } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useRoute, useRouter } from "vue-router";
import { validStEnpty } from "@/hooks/validate";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

export default defineComponent({
  name: "EditInformation",
  components: {
    Head: Head
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var router = useRouter();
    var userId = route.query.userId; //初始化下拉

    var Data = reactive({
      nation: [],
      education: [],
      degree: [{
        name: "无",
        value: 0
      }, {
        name: "学士学位",
        value: 1
      }, {
        name: "硕士学位",
        value: 2
      }, {
        name: "博士学位",
        value: 3
      }, {
        name: "博士后	",
        value: 4
      }],
      politicalIdentity: [{
        value: 1,
        name: "党员"
      }, {
        value: 0,
        name: "群众"
      }],
      form: {
        correctionTime: "",
        developmentTime: "",
        email: "",
        headIcon: "",
        incubationTime: "",
        loginName: "",
        password: "",
        userIds: "",
        account: "",
        applyTime: "",
        birthday: "",
        degree: "",
        education: "",
        gender: "",
        mobile: "",
        nation: "",
        nativePlace: "",
        organizeId: "",
        politicalIdentity: "",
        userId: "",
        username: "",
        partyDate: "",
        workingHours: "",
        organizeName: "",
        expandValues: []
      },
      expandList: [],
      dataExpand: [],
      Array: [],
      beforeArr: []
    });
    var ruleForms = ref(null);
    var ruleForms2 = ref(null);

    var contentPass = function contentPass(rule, value, callback) {
      if (!validStEnpty(Data.form.username)) {
        callback(new Error("请输入姓名"));
      } else {
        callback();
      }
    };

    var contentPass1 = function contentPass1(rule, value, callback) {
      var reg_len = /[a-zA-Z]/;

      if (!validStEnpty(Data.form.nativePlace)) {
        callback(new Error("请输入籍贯"));
      } else if (reg_len.test(value)) {
        callback(new Error('请不要包含英文字母'));
      } else {
        callback();
      }
    };

    var rules = {
      username: [{
        required: true,
        validator: contentPass,
        trigger: 'blur'
      }],
      birthday: [{
        required: true,
        message: "请输入出生年月",
        trigger: "blur"
      }],
      nation: [{
        required: true,
        message: "请选择民族",
        trigger: "blur"
      }],
      nativePlace: [{
        required: true,
        validator: contentPass1,
        trigger: 'blur'
      }],
      education: [{
        required: true,
        message: "请选择学历",
        trigger: "blur"
      }],
      degree: [{
        required: true,
        message: "请选择学位",
        trigger: "blur"
      }],
      mobile: [{
        required: true,
        message: "请输入手机号",
        trigger: "blur"
      }, {
        pattern: /^1[0-9]{10}$/,
        message: "请输入11位手机号码",
        trigger: "blur"
      }],
      politicalIdentity: [{
        required: true,
        message: "请选择",
        trigger: "blur"
      }]
    };
    var rules2 = {// expandValue: [{ required: true, message: "不能为空11", trigger: "blur" }],
    }; //const value: Ref<string> = ref("");

    function getUser() {
      return _getUser.apply(this, arguments);
    } // 只能输入英文、中文和数字


    function _getUser() {
      _getUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getUser"](userId);

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;

                if (data) {
                  Data.form.account = data.account;
                  Data.form.userId = data.userId;
                  Data.form.username = data.username;
                  Data.form.birthday = data.birthday;
                  Data.form.nation = data.nation;
                  Data.form.nativePlace = data.nativePlace.replace(/\//g, "");
                  Data.form.organizeName = data.organizeName;
                  Data.form.partyDate = data.partyDate;
                  Data.form.workingHours = data.workingHours;
                  Data.form.education = data.education;
                  Data.form.gender = data.gender;
                  Data.form.degree = data.degree;
                  Data.form.mobile = data.mobile;
                  Data.form.politicalIdentity = data.politicalIdentity;
                  Data.form.expandValues = data.expandValues;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getUser.apply(this, arguments);
    }

    function Native(value) {
      value = value.replace(/[^a-zA-Z0-9\u4E00-\u9FA5]/g, "");
      Data.form.nativePlace = value;
    } //获取民族


    function nationList() {
      return _nationList.apply(this, arguments);
    } //获取学历


    function _nationList() {
      _nationList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$globalProperti2, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["nationList"]();

              case 2:
                _yield$globalProperti2 = _context2.sent;
                data = _yield$globalProperti2.data;
                Data.nation = data;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _nationList.apply(this, arguments);
    }

    function educationList() {
      return _educationList.apply(this, arguments);
    } //获取字段


    function _educationList() {
      _educationList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$globalProperti3, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["educationList"]();

              case 2:
                _yield$globalProperti3 = _context3.sent;
                data = _yield$globalProperti3.data;
                Data.education = data;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _educationList.apply(this, arguments);
    }

    function getDetail() {
      return _getDetail.apply(this, arguments);
    } //添加条数


    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var ExpandList, DataExpand;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getExpand"]();

              case 2:
                ExpandList = _context4.sent;
                _context4.next = 5;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getExpandContent"](userId);

              case 5:
                DataExpand = _context4.sent;
                Object.assign(Data.expandList, ExpandList.data.list);
                Object.assign(Data.dataExpand, DataExpand.data);
                Data.expandList.forEach(function (val) {
                  val.arr = [];
                });
                Data.expandList.forEach(function (item) {
                  Data.dataExpand.forEach(function (item1) {
                    if (item1.expandValue) {
                      item1.expandValue.split(",").forEach(function (item2) {
                        if (item.expandId == item1.expandId) {
                          item.arr.push({
                            expandValue: item2,
                            expandId: item.expandId
                          });
                        }
                      });
                    }
                  });
                });

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _getDetail.apply(this, arguments);
    }

    function addDomainOne(item) {
      item.arr.push({
        expandValue: "",
        expandId: item.expandId
      });
    } // 删除条数


    function delDomainOne(item, index2) {
      item.arr.splice(index2, 1);
    } //记录data型入党时间
    // function setPartyDate(value) {
    //   if (value == 0) {
    //     Data.form.partyDate = ''
    //   } 
    // }
    // 验证两个form


    function checkform(formName) {
      return new Promise(function (resolve, reject) {
        // eslint-disable-next-line no-unused-vars
        var domobj;

        if (formName == "ruleForms") {
          domobj = ruleForms.value;
        } else {
          domobj = ruleForms2.value;
        }

        domobj["validate"](function (valid) {
          if (valid) {
            resolve();
          } else reject();
        });
      });
    } //编辑个人信息


    function editPerson() {
      return _editPerson.apply(this, arguments);
    }

    function _editPerson() {
      _editPerson = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var arrs, arr, idArr, list;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // //处理数据
                Data.Array = Data.expandList.filter(function (v) {
                  return v["arr"].length > 0;
                });
                arrs = Data.Array.map(function (v) {
                  return v["arr"];
                });
                arrs.forEach(function (item) {
                  item.forEach(function (item1) {
                    Data.beforeArr.push(item1);
                  });
                }); //最后结果的数组

                arr = []; //存放id值

                idArr = []; //对对象进行遍历

                Data.beforeArr.forEach(function (item) {
                  if (idArr.indexOf(item.expandId) != -1) {
                    //如果id值存在于idArr中，找到id在数组中的位置，对age进行拼接
                    var index = arr.findIndex(function (v) {
                      return v.expandId == item.expandId;
                    });
                    arr[index].expandValue += "," + item.expandValue;
                  } else {
                    //如果id值不存在于idArr，就添加上
                    idArr.push(item.expandId);
                    arr.push({
                      expandId: item.expandId,
                      expandValue: item.expandValue
                    });
                  }
                });
                Data.form.expandValues = arr;
                list = [];
                list.push(checkform("ruleForms"));
                list.push(checkform("ruleForms2"));
                Promise.all(list).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                  var data;
                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["editPerson"](Data.form);

                        case 2:
                          data = _context5.sent;

                          if (data.code == 0) {
                            ElMessage.success("编辑成功");
                            setTimeout(function () {
                              router.back();
                            }, 300);
                          }

                        case 4:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }))).catch(function () {
                  console.log("未通过");
                });

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _editPerson.apply(this, arguments);
    }

    nationList();
    educationList();
    getDetail();
    getUser();
    return _objectSpread(_objectSpread(_objectSpread({
      //value,
      addDomainOne: addDomainOne,
      delDomainOne: delDomainOne,
      Data: Data,
      editPerson: editPerson,
      ruleForms: ruleForms,
      rules: rules
    }, toRefs(Data.form)), toRefs(Data.expandList)), {}, {
      ruleForms2: ruleForms2,
      rules2: rules2,
      contentPass: contentPass,
      Native: Native //setPartyDate

    });
  }
});